import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Box, styled, Button, useTheme, Backdrop, CardMedia, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';
import PauseIcon from '@mui/icons-material/Pause';
import TimerIcon from '@mui/icons-material/Timer';
import StopIcon from '@mui/icons-material/Stop';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import AddAlarmIcon from '@mui/icons-material/AddAlarm';
import { recordingSocket, socket } from '../../../config/SocketApi';
import { useLocalStorage } from '../../../config/localStorage'
import { useAuthContext } from '../../auth/hooks/useAuthContext';
import API from '../../../config/API';
const ButtomBar = ({ room_id, onEndSession }) => {
    const { getItem, setItem, removeItem } = useLocalStorage();
    const { user } = useAuthContext() || JSON.parse(localStorage.getItem("user"));
    const [sessionStarted, setSessionStarted] = useState(false)
    const theme = useTheme();
    const { t } = useTranslation();
    const [error, setError] = useState(false)
    // const [isLoading, setIsloading] = useState(false)
    const [warnUser, setWarnUser] = useState(false)
    const [startCountDown, setStartCountDown] = useState(false)
    const [extendedTimeLeft, setExtendedTimeLef] = useState(15)
    const [preparingToEndSession, setPreparingToEndSession] = useState(false)
    const [roomStopped, setRoomStopped] = useState(false);
    const [loading, setLoading] = useState(false)
    const [countDown, setCountDown] = useState(10)
    const [elapsedTime, setELapsedTime] = useState(0)
    const [remainingTime, setRemainingTime] = useState(0)
    const [recordingPaused, setRecoringPaused] = useState(false)
    const sessionDurationRef = useRef(5400)
    const countDownRef = useRef(10)

    // Create a Styled Box with the animation
    const StyledBox = styled(Box)({
        display: 'flex',
        paddingLeft: '5px',
        paddingRight: '5px',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '5px',
        backgroundColor: theme.palette.background.gray,
        height: '50px',
        border: '3px solid',
        borderRadius: '5px',
        animation: 'blink 1s linear infinite',
        // Define the keyframes for the blinking effect directly inside
        '@keyframes blink': {
            '0%': {
                borderColor: 'white',
            },
            '50%': {
                borderColor: 'red',
            },
            '100%': {
                borderColor: 'white',
            },
        },
    });
    const ClassRoomBottomBar = styled(Box)({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 16px',
        gap: '5px',
        backgroundColor: theme.palette.background.gray,
        height: '50px',
        minHeight: '50px',
        width: '100%',
        boxSizing: 'border-box',
        flexShrink: 0,
        overflow: 'hidden',
    })
    const ButtonBox = styled(Box)({
        //flex: 1,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        // padding: '8px 24px 8px 24px',
        gap: '5px',
        marginRight: '40px',
        marginLeft: '40px',
        // backgroundColor: theme.palette.background.gray,
        // height: '50px',
        // position: 'fixed',
        // bottom: 0,
        // left: 0,
        // width: '100%'
    })
    const ActionButtonBox = styled(Box)({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '5px',
        minWidth: 0,
    })
    function secondsToHMS(seconds) {
        let hours = Math.floor(seconds / 3600);
        let minutes = Math.floor((seconds % 3600) / 60);
        let secs = Math.floor(seconds % 60);

        // Ensure it's two digits. For example, '1' becomes '01'
        if (hours < 10) hours = "0" + hours;
        if (minutes < 10) minutes = "0" + minutes;
        if (secs < 10) secs = "0" + secs;

        return hours + ':' + minutes + ':' + secs;
    }
    const handlePauseStream = () => {
        if (recordingPaused) {
            recordingSocket.emit("resume-room-recordings", { room_id })
        } else {
            recordingSocket.emit("pause-room-recordings", { room_id })
        }

        setRecoringPaused(!recordingPaused);
    }
    const handleEndSession = async () => {
        setLoading(true)
        setSessionStarted(false)
        if (onEndSession) {
            const ended = await onEndSession();
            setRoomStopped(Boolean(ended));
            setError(!ended);
            setLoading(false);
            return;
        }
        const body = JSON.stringify({
            session_id: room_id,
            new_status: 2
        })
        API.post(`session/status`, body, {
            headers: {
                Authorization: user.token,
                "Content-Type": 'application/json'
            }
        }).then(data => {
            if (data?.status === 200) {
                socket.emit("stop-room-recordings", { room_id })
                socket.emit("end-browser-page", { room_id })
                setRoomStopped(true);

            } else {
                setError(true)
            }
            setLoading(false)
        }).catch(err => {
            console.log("the error is ", err);
            setLoading(false)
            setError(true)
        })

    }

    useEffect(() => {
        let timeInterval;
        let timerValue;
        if (user && sessionStarted) {
            if (user.user_type !== 0) {
                // window.electron.send('special-page-active');
                // window.electron.receive('app-close', async () => {
                //     window.electron.send('close-confirm');
                // });

                timerValue = JSON.parse(getItem(`room-timer`));
                if (timerValue && timerValue.room_id === room_id) {
                    setELapsedTime(Math.floor((Date.now() - timerValue.timeStamp) / 1000))
                } else {
                    setItem(`room-timer`, JSON.stringify({ room_id: room_id, timeStamp: Date.now() }))
                    setELapsedTime(0)
                }
                timeInterval = setInterval(() => {
                    setELapsedTime(prev => prev + 1)
                }, 1000);

                // window.electron.receive('app-close', async () => {
                //     handleEndSession();
                //     if (timeInterval) clearInterval(timeInterval);
                //     if (user.user_type !== 0) window.electron.send('close-confirm');
                // });
            }
        }


        return () => {
            if (timeInterval) clearInterval(timeInterval)
        }
    }, [user, sessionStarted])
    const handleStartSession = () => {
        socket.emit("teacher-started-session", { room_id });
        setSessionStarted(true)
    }
    useEffect(() => {
        setRemainingTime(sessionDurationRef.current - elapsedTime)
    }, [elapsedTime])
    useEffect(() => {
        if (remainingTime < 300 && remainingTime !== 0) {
            if (remainingTime <= 10) {
                setStartCountDown(true)
            } else {
                setStartCountDown(false)
                if (extendedTimeLeft) {
                    setWarnUser(true);
                }
            }

        }


    },
        [remainingTime])

    useEffect(() => {
        let countDownInterval;
        if (startCountDown) {
            setPreparingToEndSession(true)
            setWarnUser(false)
            countDownInterval = setInterval(() => {
                if (countDownRef.current > 1) {
                    countDownRef.current -= 1
                    setCountDown(prev => prev - 1)
                } else {
                    setPreparingToEndSession(false)
                    handleEndSession()
                }
            }, 1000);
        }
        return () => {
            if (countDownInterval) clearInterval(countDownInterval)
        }
    }, [startCountDown])
    const extendSessionTime = () => {
        if (extendedTimeLeft === 15) {
            setExtendedTimeLef(5);
            setRemainingTime(prev => prev + 600)
            sessionDurationRef.current = sessionDurationRef.current + 600;
            setWarnUser(false);
        } else if (extendedTimeLeft === 5) {
            setExtendedTimeLef(false);
            setRemainingTime(prev => prev + 300)
            sessionDurationRef.current = sessionDurationRef.current + 300;
            setWarnUser(false);
        }
    }
    return (
        <ClassRoomBottomBar>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CardMedia component="img"
                    image="./assets/loading.gif"
                    sx={{ width: '8rem' }}
                />
            </Backdrop>
            <ActionButtonBox >
                {sessionStarted && <Button disabled={roomStopped} onClick={handleEndSession} sx={{ pr: theme.direction === "rtl" ? '0px' : '10px', color: theme.palette.secondary.main, borderColor: theme.palette.secondary.main }} variant="outlined" startIcon={<StopIcon sx={{ ml: theme.direction === "rtl" ? '10px' : '0px' }} />} >
                    {t("stopSession")}
                </Button>}
                {!sessionStarted && <Button disabled={roomStopped} onClick={handleStartSession} sx={{ pr: theme.direction === "rtl" ? '0px' : '10px', color: theme.palette.secondary.main, borderColor: theme.palette.secondary.main }} variant="outlined" startIcon={<PlayArrowIcon sx={{ ml: theme.direction === "rtl" ? '10px' : '0px' }} />} >
                    {t("startSession")}
                </Button>}
                <Button onClick={handlePauseStream} sx={{ pr: theme.direction === "rtl" ? '0px' : '10px', color: theme.palette.secondary.main, borderColor: theme.palette.secondary.main }} variant="outlined" startIcon={<PauseIcon sx={{ ml: theme.direction === "rtl" ? '10px' : '0px' }} />} >
                    {!recordingPaused ? t("pause") : t("resume")}
                </Button>
                {(warnUser && extendedTimeLeft) && <StyledBox>
                    <Typography sx={{ color: theme.palette.secondary.main }}>{t("fiveMinLeft")}</Typography>
                    <Button onClick={extendSessionTime} sx={{ pr: theme.direction === "rtl" ? '0px' : '10px', color: theme.palette.secondary.main, borderColor: theme.palette.secondary.main }} variant="outlined" startIcon={<AddAlarmIcon sx={{ ml: theme.direction === "rtl" ? '10px' : '0px' }} />} >
                        {extendedTimeLeft === 15 ? t("extend10") : t("extend5")}
                    </Button>
                </StyledBox>}
                {preparingToEndSession && <StyledBox>
                    <Typography sx={{ color: theme.palette.secondary.main }}>{t("preparingEndSession")}</Typography>
                    <Typography sx={{ color: theme.palette.secondary.main, fontSize: '1.2em' }}>{countDown}</Typography>
                </StyledBox>}
                {error && <StyledBox>
                    <Typography sx={{ color: theme.palette.secondary.main }}>{t("errorEndingSession")}</Typography>
                </StyledBox>}
            </ActionButtonBox>
            <ButtonBox>
                <Button sx={{ width: '230px', pr: theme.direction === "rtl" ? '0px' : '10px', color: theme.palette.secondary.main, borderColor: theme.palette.secondary.main }} disabled variant="outlined" startIcon={<TimerIcon sx={{ ml: theme.direction === "rtl" ? '10px' : '0px' }} />}>
                    {t("elapsed")}: {secondsToHMS(elapsedTime)}
                </Button>
                <Button sx={{ width: '230px', pr: theme.direction === "rtl" ? '0px' : '10px', color: theme.palette.secondary.main, borderColor: theme.palette.secondary.main }} disabled variant="outlined" startIcon={<TimerIcon sx={{ ml: theme.direction === "rtl" ? '10px' : '0px' }} />}>
                    {t("remaining")}: {secondsToHMS(remainingTime)}
                </Button>
            </ButtonBox>

        </ClassRoomBottomBar>
    )
}

export default ButtomBar
